import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { SleepJson } from '@/types/domain/sleep/entities/sleepEntity';

import { sleepSlice } from '@/domain/sleep/redux';
import { service } from '@/share';

export const refreshSleepList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'sleep/refreshSleepList',
  async (_, thunkApi) => {
    const result: {
      items: SleepJson[],
      nextToken: string,
    } = await service.sleep.getSleepList(null);
    thunkApi.dispatch(sleepSlice.actions.setSleepList(result));
  },
);

export const getSleepList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'sleep/getSleepList',
  async (_, thunkApi) => {
    const { nextToken, sleepList } = thunkApi.getState().sleep;
    if (!nextToken) {
      if (sleepList.length === 0) {
        thunkApi.dispatch(refreshSleepList());
      }
      return;
    }
    const result: {
      items: SleepJson[],
      nextToken: string,
    } = await service.sleep.getSleepList(nextToken);
    const newList = sleepList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(sleepSlice.actions.setSleepList(
      {
        items: newList,
        nextToken: result.nextToken,
      },
    ));
  },
);

export const createSleep = createAsyncThunk<
  void,
  {
    /** データ */
    data: SleepJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'sleep/create',
  async (input, _thunkApi) => {
    await service.sleep.createSleep(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.sleepNursery.sendNurserySleep({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteSleep = createAsyncThunk<
  void,
  {
    /** データ */
    data: SleepJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'sleep/delete',
  async (input, _thunkApi) => {
    await service.sleep.deleteSleep(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.sleepNursery.removeNurserySleep({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
